export default {"src":"/_next/static/media/quality.f4caac68.svg","height":121,"width":120};